import './index.scss';

import { AutoComplete, Button, Col, Form, Input, Modal, Row, Select, Spin } from 'antd';
import React, { PureComponent } from 'react';

import { ImageLoader } from 'cleaning-lots/components/CleaningUI/ImageLoader';
import PropTypes from 'prop-types';
import birthDeathTypes from '../../../../../src/utils/birth-death-types';
import { getAuthorUrl, getUlanUrl, getUlanUrlSearch } from 'shared/tools/url';
import { isNil } from 'lodash';
import nationalities from 'shared/constants/nationalities';

const { TextArea } = Input;

class EditArtistModal extends PureComponent {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    updateArtist: PropTypes.func.isRequired,
    navigateToPrevArtist: PropTypes.func.isRequired,
    navigateToNextArtist: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isPrevButtonDisabled: PropTypes.bool.isRequired,
    isNextButtonDisabled: PropTypes.bool.isRequired,

    form: PropTypes.shape({
      getFieldDecorator: PropTypes.func.isRequired,
      getFieldsValue: PropTypes.func.isRequired,
    }).isRequired,

    artistToEdit: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      first_name: PropTypes.string,
      surname: PropTypes.string,
      moniker: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    artistQualifiers: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      nationalities,
    };
  }

  onOk = () => {
    const {
      form: { validateFieldsAndScroll },
      artistToEdit,
      updateArtist,
    } = this.props;

    validateFieldsAndScroll((err, fields) => {
      if (!err) {
        updateArtist(artistToEdit.id, fields);
      }
    });
  };

  navigateToArtist = navigateCallback => () => {
    const {
      form: { resetFields },
    } = this.props;

    resetFields();
    navigateCallback();
  };

  getFieldValue = fieldName => {
    const formValues = this.props.form.getFieldsValue();
    return formValues[fieldName];
  };

  render() {
    const {
      form: { getFieldDecorator, isFieldsTouched },
      artistToEdit,
      visible,
      closeModal,
      navigateToPrevArtist,
      navigateToNextArtist,
      isLoading,
      isPrevButtonDisabled,
      isNextButtonDisabled,
    } = this.props;
    const title = (
      <div className="edit-artist__title">
        <Button
          type="primary"
          shape="circle"
          icon="left"
          onClick={this.navigateToArtist(navigateToPrevArtist)}
          disabled={isPrevButtonDisabled}
        />
        <span>Edit Artist</span>
        <Button
          type="primary"
          shape="circle"
          icon="right"
          onClick={this.navigateToArtist(navigateToNextArtist)}
          disabled={isNextButtonDisabled}
        />
      </div>
    );

    return (
      <Modal
        title={title}
        visible={visible}
        onCancel={closeModal}
        okText="Save"
        okButtonProps={{
          disabled: !isFieldsTouched() || isLoading,
          onClick: this.onOk,
        }}
        width="50vw"
        bodyStyle={{
          height: '70vh',
          overflowY: 'scroll',
        }}
      >
        {isLoading ? (
          <div className="edit-artist__spin">
            <Spin />
          </div>
        ) : (
          <Form onSubmit={this.onSubmit}>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item label="Name">
                  {getFieldDecorator('name', {
                    initialValue: artistToEdit.name,
                  })(<Input disabled />)}
                  <Button href={getAuthorUrl(artistToEdit.id)} target="blank">
                    View Artist
                  </Button>
                </Form.Item>
                <Form.Item label="First Name">
                  {getFieldDecorator('first_name', {
                    initialValue: artistToEdit.first_name,
                  })(<Input />)}
                </Form.Item>
                <Form.Item label="Surname">
                  {getFieldDecorator('surname', {
                    initialValue: artistToEdit.surname,
                  })(<Input />)}
                </Form.Item>
                <Form.Item label="Moniker">
                  {getFieldDecorator('moniker', {
                    initialValue: artistToEdit.moniker,
                  })(<Input />)}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
      </Modal>
    );
  }
}

export default EditArtistModal;
